<template>
  <component :is="tag" v-bind="$attrs" :class="classes" @click="$emit('click', $event)">
    <slot>{{label}}</slot>
    <svg-icon v-if="$attrs.target == '_blank'" class="icon" :icon="'new_window'" />
  </component>
</template>

<script>
  export default {
    name: 'TextLink',
    components: {
      SvgIcon: () => import('@/components/atoms/SvgIcon')
    },
    props: {
      label: {
        type: String,
        default: ''
      },
    },
    computed: {
      tag() {
        return this.$attrs.href ? 'a' : 'button'
      },
      classes() {
        const classes = ['text-link']
        if(this.$attrs.target == '_blank') classes.push('is-new-window')
        return classes
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';

  .text-link {
    text-decoration: none;
    font-weight: 400;
    color: $color-link;

    .icon {
      width: .85em;
      height: .85em;
      display: inline-block;
      vertical-align: middle;
      margin: -.2em 0 0 8px;
      fill: $color-link;
    }
  }
</style>